import React, { useState } from "react";
import BannerBottomImage1 from "../assets/banner-bottom/banner-bottom-1.webp";
import BannerBottomImage2 from "../assets/banner-bottom/banner-bottom-2.webp";
import BannerBottomImage3 from "../assets/banner-bottom/banner-bottom-3.webp";
import { BsCheck2 } from "react-icons/bs";
import languageStorage from "../lang/findLanguage";

export default function BannerBottom({ language }) {
  const [data] = useState([
    {
      id: 1,
      title: languageStorage() === "tr" ? language[0].sections[2].keys[1].k0002 : language[1].sections[2].keys[1].k0002,
      img: BannerBottomImage1,
      text: [
        languageStorage() === "tr" ? language[0].sections[2].keys[2].k0003 : language[1].sections[2].keys[2].k0003,
        languageStorage() === "tr" ? language[0].sections[2].keys[3].k0004 : language[1].sections[2].keys[3].k0004,
      ],
    },
    {
      id: 2,
      title: languageStorage() === "tr" ? language[0].sections[2].keys[4].k0005 : language[1].sections[2].keys[4].k0005,
      img: BannerBottomImage2,
      text: [
        languageStorage() === "tr" ? language[0].sections[2].keys[5].k0006 : language[1].sections[2].keys[5].k0006,
        languageStorage() === "tr" ? language[0].sections[2].keys[6].k0007 : language[1].sections[2].keys[6].k0007,
      ],
    },
    {
      id: 3,
      title: languageStorage() === "tr" ? language[0].sections[2].keys[7].k0008 : language[1].sections[2].keys[7].k0008,
      img: BannerBottomImage3,
      text: [
        languageStorage() === "tr" ? language[0].sections[2].keys[8].k0009 : language[1].sections[2].keys[8].k0009,
        languageStorage() === "tr" ? language[0].sections[2].keys[9].k0010 : language[1].sections[2].keys[9].k0010,
      ],
    },
  ]);

  return (
    <section className="banner-bottom" id={languageStorage() === "tr" ? language[0].sections[11].keys[0].k0001 : language[1].sections[11].keys[0].k0001}>
      <div className="container d-flex flex-column align-items-center justify-content-center">
        <p className="banner-bottom-desc">{languageStorage() === "tr" ? language[0].sections[2].keys[0].k0001 : language[1].sections[2].keys[0].k0001}</p>
        <div className="banner-bottom-items">
          {data.map((item) => (
            <div className="banner-bottom-item d-flex flex-column align-items-center" key={item.id}>
              <img src={item.img} alt={item.title} height="134px" width="134px" />
              <h4>{item.title}</h4>
              {item.text.map((subItem, index) => (
                <p className="banner-bottom-item-text" key={index}>
                  <BsCheck2 size="20" color="#DF500E" />
                  <span>{subItem}</span>
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
